import { render, staticRenderFns } from "./LpCheckGroup.vue?vue&type=template&id=a045ada8&scoped=true"
import script from "./LpCheckGroup.vue?vue&type=script&lang=js"
export * from "./LpCheckGroup.vue?vue&type=script&lang=js"
import style0 from "./LpCheckGroup.vue?vue&type=style&index=0&id=a045ada8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a045ada8",
  null
  
)

export default component.exports